import { UserGroup as Base } from '@whispli/client/tenant/openapi/client/model/UserGroup'
import { MEMBERSHIPABLE_TYPE_ENUM } from '@whispli/client/tenant/constants'

export class UserGroup extends Base {
  get type() {
    return MEMBERSHIPABLE_TYPE_ENUM.USER_GROUPS
  }
}
